import { useMutation, useQueryClient } from '@tanstack/react-query';

type DeleteAdminUserParams = {
  id: number;
};

export default function useDeleteAdminUser() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: DeleteAdminUserParams) => {
      const response = await fetch(`/admin/api/users/${params.id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
      });
      if (!response.ok) {
        throw new Error('ユーザーの削除に失敗しました');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
    },
  });
}
